import { Url } from '@42.nl/react-url';

export const LOGIN_URL = '/login';

export function toLogin(): Url {
  return LOGIN_URL;
}
